import generalNotifSound from 'assets/audio/general-notif.wav';
import chatNotifSound from 'assets/audio/chat-notif.wav';

const AudioMixin = {
    methods: {
        _playGeneralNotificationSound() {
            const audio = new Audio(generalNotifSound);
            audio.play();
        },
        _playChatNotificationSound() {
            const audio = new Audio(chatNotifSound);
            audio.play();
        }
    }
};

export default AudioMixin;
